module.exports = __webpack_public_path__ + "static/img/or-shelf-slope-accessible-colorbar.30af04b.png";